let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("azZqs")).then(() => parcelRequire('6pPz6'));